export default {
  modal: {
    title: 'Would you like to order this test?',
    message:
      'This order counts as one free test included in your membership. Your order will be processed immediately and shipped to your address on file.',
  },
  blurb: 'We’ve updated your address in your account settings.',
};
